<template>
  <q-dialog
    :model-value="modelValue"
    persistent
    @update:model-value="emit('update:modelValue', $event)"
  >
    <q-card style="min-width: 500px">
      <q-card-section class="row items-center q-pb-none">
        <div class="text-h6">Add DDC Panel</div>
        <q-space />
        <q-btn v-close-popup icon="close" flat round dense />
      </q-card-section>

      <q-form @submit="onSubmit" @reset="onReset">
        <q-card-section>
          <q-select
            :model-value="formData.parent_mssb"
            label="Parent MSSB *"
            filled
            :options="mssbOptions"
            emit-value
            map-options
            :rules="[val => !!val || 'Parent MSSB is required']"
            class="q-mb-md"
            @update:model-value="emit('update:parent-mssb', $event)"
          />

          <q-input
            :model-value="formData.name"
            label="Name *"
            filled
            :rules="[val => !!val || 'Name is required']"
            class="q-mb-md"
            @update:model-value="emit('update:name', $event)"
          />

          <q-input
            :model-value="formData.description"
            label="Description"
            filled
            type="textarea"
            rows="2"
            class="q-mb-md"
            @update:model-value="emit('update:description', $event)"
          />

          <q-input
            :model-value="formData.number_of_points"
            label="Number of Points"
            filled
            type="number"
            min="0"
            class="q-mb-md"
            @update:model-value="emit('update:number-of-points', $event)"
          />

          <q-select
            :model-value="formData.controller_type"
            label="Controller Type"
            filled
            :options="controllerTypeOptions"
            class="q-mb-md"
            @update:model-value="emit('update:controller-type', $event)"
          />

          <q-select
            :model-value="formData.location"
            label="Location"
            filled
            :options="locationOptions"
            emit-value
            map-options
            @update:model-value="emit('update:location', $event)"
          />
        </q-card-section>

        <q-card-actions align="right">
          <q-btn v-close-popup flat label="Cancel" color="grey" />
          <q-btn flat label="Reset" type="reset" color="warning" />
          <q-btn unelevated label="Save" type="submit" color="yellow" text-color="black" :loading="saving" />
        </q-card-actions>
      </q-form>
    </q-card>
  </q-dialog>
</template>

<script setup>
  const props = defineProps({
    modelValue: {
      type: Boolean,
      default: false,
    },
    formData: {
      type: Object,
      required: true,
    },
    mssbOptions: {
      type: Array,
      default: () => [],
    },
    controllerTypeOptions: {
      type: Array,
      default: () => [],
    },
    locationOptions: {
      type: Array,
      default: () => [],
    },
    saving: {
      type: Boolean,
      default: false,
    },
  });

  const emit = defineEmits([
    'update:modelValue',
    'update:parent-mssb',
    'update:name',
    'update:description',
    'update:number-of-points',
    'update:controller-type',
    'update:location',
    'submit',
    'reset',
  ]);

  function onSubmit() {
    emit('submit');
  }

  function onReset() {
    emit('reset');
  }
</script>
